import { OptimalBlueAdjustmentType } from 'constants/loanApplication';

export const CustomAdjustmentType = {
  CUSTOM_ADJUSTMENT: 'CustomAdjustment',
  EXTENSION: 'Extension',
  FLOAT_DOWN: 'FloatDown',
  AUTO_ADJUSTMENTS: 'AutoAdjustment',
};

export const adjustmentsModifiedFieldsToExclude = [];

export const DEFAULT_ERROR_MESSAGE_LOCK_EXTENSION_COST_CALCULATION =
  'Failed to calculate lock extension cost';

export const optimalBlueAdjustmentTypesWithPricePrefix = [OptimalBlueAdjustmentType.PRICE];

export const OPTIMAL_BLUE_ADJUSTMENT_PRICE_PREFIX = 'Price';
